// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import type { FullUserType } from 'types/User';
import { getPlaceholder } from 'utils/assetsUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  userPref: FullUserType
};

type Props = StateProps & {
  title: string,
  link: string,
  nombreDePlace: number,
  exclusivite: string,
  position: string,
  cadeau: string,
  prix: number,
  placeDeParking: string,
  repas: string,
  image: string,
  logeDescription: string
};

class CardLoge extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    title: '',
    link: '',
    nombreDePlace: 0,
    exclusivite: '',
    position: '',
    cadeau: '',
    prix: 0,
    placeDeParking: '',
    repas: '',
    image: '',
    logeDescription: ''
  };

  clickTagEvent = (logeTitle: string) => {
    const { userPref } = this.props;

    return handleTagEvent(
      'offres_entreprises_match',
      'clic_decouvrir',
      logeTitle,
      userPref,
      handleTagEvent('recherche_offre_match', 'decouvrir', logeTitle, userPref)
    );
  };

  clickContactTagEvent = (logeTitle: string) => {
    const { userPref } = this.props;

    return handleTagEvent(
      'recherche_offre_match',
      'recontacte',
      logeTitle,
      userPref,
      handleTagEvent('offres_entreprises_match', 'clic_contact', logeTitle, userPref)
    );
  };

  render() {
    const {
      link,
      title,
      nombreDePlace,
      exclusivite,
      position,
      cadeau,
      prix,
      placeDeParking,
      repas,
      image,
      logeDescription
    } = this.props;
    let src = image;

    if (image === '') {
      src = getPlaceholder();
    }

    return (
      <div className="box box--white card card--ticket card--offer mb-4">
        <Link to={link} title={`${title}`} className="card__header">
          <div className="card__thumbnail" style={{ backgroundImage: `url(${src})` }}>
            {image !== '' && <img src={src} alt={`Image d'illustration de l'offre ${title}`} />}
          </div>
        </Link>
        <div className="card__body">
          <h3 className="ft-h2 mb-2">{title}</h3>
          { logeDescription && <p className="card--offer__description">{logeDescription}</p>}
          
          <ul>
            {nombreDePlace > 0 && (
              <li>
                <i className="icon icon-jersey is-inline"></i>
                <p className="ft-700 ft-up ft-tertiary ft-black-secondary mb-0">{nombreDePlace} places</p>
              </li>
            )}
            {exclusivite !== '' && (
              <li>
                <i className="icon icon-star is-inline"></i>
                <p className="ft-700 ft-up ft-tertiary ft-black-secondary mb-0">{exclusivite}</p>
              </li>
            )}
            {cadeau !== '' && (
              <li>
                <i className="icon icon-gift is-inline"></i>
                <p className="ft-700 ft-up ft-tertiary ft-black-secondary mb-0">{cadeau}</p>
              </li>
            )}
            {position !== '' && (
              <li>
                <i className="icon icon-place is-inline"></i>
                <p className="ft-700 ft-up ft-tertiary ft-black-secondary mb-0">{position}</p>
              </li>
            )}
            {placeDeParking !== '' && (
              <li>
                <i className="icon icon-car is-inline"></i>
                <p className="ft-700 ft-up ft-tertiary ft-black-secondary mb-0">{placeDeParking}</p>
              </li>
            )}
            {repas !== '' && (
              <li>
                <i className="icon icon-food is-inline"></i>
                <p className="ft-700 ft-up ft-tertiary ft-black-secondary mb-0">{repas}</p>
              </li>
            )}
          </ul>
        </div>
        <div className="card__footer">
          {prix > 0 && (
            <div className="card--offer__price">
              <p className="ft-700 ft-up ft-tertiary ft-black-tertiary mb-0">À partir de</p>
              <p className="ft-h3 ft-300 ft-expo mb-0">
                {prix} € HT <span>/pers.</span>
              </p>
            </div>
          )}
          <div className="card--offer__buttons">
            <Link to={link} title={title} className="btn btn--primary" onClick={this.clickTagEvent(title)}>
              <span>Découvrir</span>
            </Link>
            <Link
              to={{
                pathname: `/contact/nous-contacter`,
                state: {
                  object: `Demande d'offre hospitalité`,
                  link,
                  isPopulate: true,
                  isOffer: true
                }
              }}
              title="Être recontacté"
              className="btn btn--white"
              onClick={this.clickContactTagEvent(title)}
            >
              <span>Être recontacté</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
export default CardLoge;
